import Image from 'next/image';
import React from 'react';

import { tw } from '../../utils';

export interface IconProps {
  name: string;
  height: number;
  width: number;
  className?: string;
  alt?: string;
  src?: string;
  folder?: string;
  baseURL?: string;
  onClick?: () => void;
}

export const Icon: React.FC<IconProps> = ({
  name,
  className = '',
  alt,
  src,
  folder,
  height,
  width,
  baseURL,
  onClick,
}: IconProps) => {
  return (
    <Image
      src={
        src ??
        `${baseURL ?? process.env.NEXT_PUBLIC_WEARABLES_CDN}/stoodio/icons/${
          folder ?? 'interface'
        }/${name}.svg`
      }
      height={height}
      width={width}
      alt={alt || name}
      className={`${tw(className)}`}
      onClick={onClick}
      style={{
        height: `${height}px`,
        width: `${width}px`,
      }}
    />
  );
};

export default Icon;
